module.exports = __webpack_public_path__ + "static/media/home-splash.5a1ead17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/home-splash.svg
// module id = 582
// module chunks = 19